/**
 * Client configuration. Set these at build time via Vite env vars:
 *   VITE_WORKER_WS_BASE   e.g. wss://mov-watchparty.<subdomain>.workers.dev
 *   VITE_WORKER_HTTP_BASE e.g. https://mov-watchparty.<subdomain>.workers.dev
 *   VITE_VIDEO_BASE       e.g. https://<public-r2-domain>   (serves HLS output)
 *
 * Defaults point at local `wrangler dev` so the app runs out of the box.
 */
// Dev values come from .env.development (localhost, loaded only by `vite dev`);
// production values from .env.production (see .env.example). A missing var
// resolves to "" so a misconfigured prod build fails loudly rather than silently
// targeting each viewer's own localhost.
export const WORKER_WS_BASE: string = import.meta.env.VITE_WORKER_WS_BASE ?? "";
export const WORKER_HTTP_BASE: string = import.meta.env.VITE_WORKER_HTTP_BASE ?? "";
export const VIDEO_BASE: string = import.meta.env.VITE_VIDEO_BASE ?? "";

/** Build the HLS master playlist URL for a given movie id. */
export function masterUrl(movieId: string): string {
  const base = VIDEO_BASE.replace(/\/$/, "");
  return `${base}/movies/${encodeURIComponent(movieId)}/master.m3u8`;
}

/** English WebVTT subtitle sidecar for a movie (served next to the HLS output).
 * The ?v bump forces a fresh fetch after we re-time the subtitle file. */
const SUBTITLE_VERSION = 3;
export function subtitleUrl(movieId: string): string {
  const base = VIDEO_BASE.replace(/\/$/, "");
  return `${base}/movies/${encodeURIComponent(movieId)}/subs.en.vtt?v=${SUBTITLE_VERSION}`;
}

/** Google "Sign in with Google" OAuth Client ID (public — safe to ship in the
 * page). Requests only name/email/profile — no Gmail, no sensitive scopes. */
export const GOOGLE_CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ??
  "44162548672-e10qpg36ekmf7oa6nmqduj6a8irte9e3.apps.googleusercontent.com";
